import React from 'react';
import { usePermissions } from '../hooks/usePermissions';

const PermissionGate = ({ 
  children, 
  permission, 
  permissions, 
  requireAll = false, 
  role, 
  fallback = null,
  showError = false 
}) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions, hasRole } = usePermissions();

  let hasAccess = true;

  // Check role-based access
  if (role) {
    hasAccess = hasAccess && hasRole(role);
  }

  // Check permission-based access
  if (permission) {
    hasAccess = hasAccess && hasPermission(permission);
  }

  if (permissions && permissions.length > 0) {
    if (requireAll) {
      hasAccess = hasAccess && hasAllPermissions(permissions);
    } else {
      hasAccess = hasAccess && hasAnyPermission(permissions);
    }
  }

  // If no access, return fallback or null
  if (!hasAccess) {
    if (showError) {
      return (
        <div className="alert alert-danger" role="alert">
          <h4 className="alert-heading">غير مسموح</h4>
          <p>ليس لديك صلاحية للوصول إلى هذا المحتوى.</p>
        </div>
      );
    }
    return fallback;
  }

  return children;
};

export default PermissionGate;
